import React, { useCallback, useState, useEffect } from 'react'
import styled from 'styled-components'

import Row from '../../components/Row'
import prev from '../../assets/images/prev.png'

const Pagination = styled.div`
  width: 100%;
  font-size: 14px;
  text-align: center;
`
const PageUl = styled(Row)`
  justify-content: flex-end;
`
const PageLi = styled.div<{img?: string, rotate?: string}>`
  padding: 0 3px;
  margin-right: 10px;
  min-width: 38px;
  height: 38px;
  line-height: 38px;
  cursor: pointer;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(214, 164, 133, 0.3);
  color: ${({ theme }) => theme.bsBg12};
  font-family: Baloo Da;
  background-image: url(${({img}) => (img ? img : '')});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  transform: rotate(${({rotate}) => (rotate ? rotate : '')});
  &.active {
    color: ${({ theme }) => theme.bsText12};
  }
  &.disabled {
    background-color: #EED9CC;
    opacity: 0.3;
  }
  &:last-child {
    margin-right: 0px;
  }
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 25px;
    height: 25px;
    line-height: 25px;
    font-size: 13px;
  `}
`
const parameter = {
  curPage: 1,
  midNum: 3,
  flip: 8
}
export default function Paginator({pageCount, curPage, page}: {pageCount: number, curPage: number, page: (value: number)=>void}) {
  const [middlePage, setMiddlePage] = useState([0])
  const [bigLimit, setBigLimit] = useState(0)
  const middlePages = useCallback(() => {
    var num = 0
    var ary = []
    if (pageCount <= 2) {
      num = 0
    } else if (pageCount > 2 && pageCount <= parameter.flip) {
      num = pageCount - 2
    } else {
      num = parameter.midNum
    }
    for (let i = 0; i < num; i++) {
      ary.push(i)
    }
    setMiddlePage(ary)
  }, [pageCount])

  const bigLimits = useCallback(() => {
    setBigLimit(pageCount - 2)
  }, [pageCount])

  useEffect(() => {
    middlePages()
    bigLimits()
  }, [pageCount, middlePages, bigLimits])

  const [offset, setOffset] = useState(0)
  useEffect(() => {
    if (pageCount <= parameter.flip || curPage <= parameter.midNum) {
      setOffset(2)
    } else if (curPage >= bigLimit) {
      setOffset(bigLimit - 1)
    } else {
      setOffset(curPage - 1)
    }
  }, [curPage, pageCount, bigLimit])

  const prevPage = useCallback(() => {
    if (curPage !== 1) {
      page(curPage - 1)
    }
  }, [curPage, page])

  const nextPage = useCallback(() => {
    if (curPage !== pageCount) {
      page(curPage + 1)
    }
  }, [curPage, pageCount, page])

  return (
    <>
      <Pagination>
        <PageUl>
          <PageLi img={prev} className={curPage === 1 ? 'disabled' : ''} onClick={prevPage}></PageLi>
          <PageLi className={curPage === 1 ? 'active' : ''} onClick={() => {page(1)}}>1</PageLi>
          {
            curPage > parameter.midNum && pageCount > parameter.flip && (
              <PageLi>...</PageLi>
            )
          }
          {
            middlePage.map((d)=> {
              return (
                <PageLi className={curPage === d + offset ? 'active' : ''} key={d} onClick={() => {page(d + offset)}}>{d + offset}</PageLi>
              )
            })
          }
          {
            curPage < bigLimit && pageCount > parameter.flip && (
              <PageLi>...</PageLi>
            )
          }
          {
            pageCount > 1 && (
              <PageLi className={curPage === pageCount ? 'active' : ''} onClick={() => {page(pageCount)}}>{pageCount}</PageLi>
            )
          }
          <PageLi img={prev} rotate="180deg" className={curPage === pageCount ? 'disabled' : ''} onClick={nextPage}></PageLi>
        </PageUl>
      </Pagination>
    </>
  )
}